import { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { REVIEWS } from "../../data/site";
import { Kicker } from "./Reveal";

export const Reviews = () => {
  const [i, setI] = useState(0);
  const [dir, setDir] = useState(1);
  const n = REVIEWS.length;

  const go = useCallback((d) => { setDir(d); setI((p) => (p + d + n) % n); }, [n]);

  useEffect(() => {
    const t = setInterval(() => go(1), 6000);
    return () => clearInterval(t);
  }, [go]);

  const r = REVIEWS[i];

  return (
    <section id="reviews" className="relative overflow-hidden bg-ffc-blue py-24 lg:py-32" data-testid="reviews">
      <Quote className="pointer-events-none absolute -left-6 top-16 h-52 w-52 text-white/5" />
      <div className="relative mx-auto max-w-4xl px-5 text-center lg:px-10">
        <div className="flex justify-center">
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-white/70">
            <span className="h-px w-8 bg-ffc-red" /> Customer Reviews
          </span>
        </div>
        <h2 className="font-display mx-auto mt-4 max-w-2xl text-4xl font-extrabold text-white sm:text-5xl">
          Loved across Charlotte.
        </h2>

        <div className="relative mt-12 min-h-[280px]">
          <AnimatePresence mode="wait" custom={dir}>
            <motion.div key={i} custom={dir}
              initial={{ opacity: 0, x: dir * 60 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: dir * -60 }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`review-${i}`}>
              <div className="flex justify-center gap-1">
                {[...Array(5)].map((_, k) => <Star key={k} className="h-5 w-5 fill-[#FFC107] text-[#FFC107]" />)}
              </div>
              <p className="font-display mx-auto mt-6 max-w-3xl text-2xl font-medium leading-snug text-white sm:text-3xl">
                “{r.text}”
              </p>
              <div className="mt-8 flex items-center justify-center gap-4">
                <img src={r.photo} alt={r.name} className="h-14 w-14 rounded-full object-cover ring-2 ring-white/30" />
                <div className="text-left">
                  <div className="font-bold text-white">{r.name}</div>
                  <div className="text-sm text-white/60">{r.role}</div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-10 flex items-center justify-center gap-4">
          <button onClick={() => go(-1)} data-testid="review-prev"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors hover:bg-white hover:text-ffc-blue">
            <ChevronLeft className="h-5 w-5" />
          </button>
          <div className="flex gap-2">
            {REVIEWS.map((_, k) => (
              <button key={k} onClick={() => { setDir(k > i ? 1 : -1); setI(k); }}
                aria-label={`Review ${k + 1}`}
                className={`h-2 rounded-full transition-all ${k === i ? "w-8 bg-ffc-red" : "w-2 bg-white/30"}`} />
            ))}
          </div>
          <button onClick={() => go(1)} data-testid="review-next"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors hover:bg-white hover:text-ffc-blue">
            <ChevronRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </section>
  );
};
